module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal-non-clickable', {
    class: _vm.getClassMobile(),
    style: (_vm.modalStyle()),
    attrs: {
      "show": _vm.show,
      "data-backdrop": "static",
      "clickToClose": "false",
      "data-keyboard": "false"
    },
    on: {
      "close": _vm.close
    }
  }, [_c('div', {
    style: (_vm.mainDivStyle())
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h3', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_choose_exist_training")) + " - " + _vm._s(_vm.selectedDate))]), _vm._v(" "), _c('i', {
    staticClass: "ti-close",
    on: {
      "click": _vm.close
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }],
    staticClass: "form-control input",
    staticStyle: {
      "width": "95%",
      "border-radius": "10px"
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.locale.t('label_search_trainings_definition'),
      "name": "users"
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "keyup": _vm.keymonitor,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.successAdd.length > 0) ? _c('div', {
    staticStyle: {
      "margin-left": "16px"
    }
  }, [_c('label', {
    staticStyle: {
      "color": "#4caf50"
    }
  }, [_vm._v(_vm._s(_vm.successAdd))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "content table-responsive table-full-width",
    style: (_vm.tableStyle())
  }, [_c('table', {
    staticClass: "table-main table-main--fixed"
  }, [_c('thead', [_c('tr', [(_vm.visibleImage) ? _c('th', {
    staticStyle: {
      "width": "100px",
      "color": "white"
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_picture")))]) : _vm._e(), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "200px",
      "color": "white"
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_td_name")))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "200px",
      "color": "white"
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_td_short_desc")))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "200px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_select")))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.trainings), function(item) {
    return _c('tr', [(_vm.visibleImage) ? _c('td', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "data-title": _vm.locale.t('label_picture')
      }
    }, [(item.imageUrl != null && item.imageUrl.length > 0) ? _c('img', {
      staticClass: "cropped1",
      staticStyle: {
        "width": "50px",
        "height": "50px"
      },
      attrs: {
        "src": item.imageUrl
      }
    }) : _vm._e(), _vm._v(" "), (item.imageUrl == null || item.imageUrl.length === 0) ? _c('img', {
      staticClass: "cropped1-missing",
      staticStyle: {
        "width": "50px",
        "height": "50px"
      },
      attrs: {
        "src": require("../assets/img/icons/missing_image.svg")
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_td_name')
      }
    }, [_vm._v(_vm._s(_vm.checkNullEmpty(_vm.getName(item))))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_td_short_desc')
      }
    }, [_vm._v(_vm._s(_vm.checkNullEmpty(_vm.getShortDesc(item))))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "data-title": _vm.locale.t('label_select')
      },
      on: {
        "click": function($event) {
          return _vm.chooseItem(item)
        }
      }
    }, [_c('div', {
      staticClass: "new-button"
    }, [_c('i', {
      staticClass: "ti-check"
    }), _vm._v(" " + _vm._s(_vm.locale.t("label_select")) + "\n                  ")])])])
  }), 0)]), _vm._v(" "), (_vm.pagination.totalCount > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('pagination', {
    attrs: {
      "active-page": _vm.pagination.page,
      "total": _vm.pagination.totalCount,
      "limit": _vm.pagination.limit
    }
  })], 1)]) : _vm._e()])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-fcfe2ae2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modals/ChooseTrainingDefinition.vue
// module id = 863
// module chunks = 0